import { FiRefreshCcw } from 'react-icons/fi';
import './Button-reload.scss';

interface ButtonReloadProps {
  onClick: () => void;
}

const ButtonReload = ({ onClick }: ButtonReloadProps) => {
  return (
    <button className="button-reload" onClick={onClick}>
      <FiRefreshCcw className="icon" />
    </button>
  );
};

export default ButtonReload;
